import { createContext, useContext } from "react";
import { A11Y_OFF } from "../utils/a11y.js";

// SOK-09: estado del modo accesible; lo provee A11yProvider (src/components/A11yProvider.jsx).
export const A11yContext = createContext({
  settings: A11Y_OFF,
  active: false,
  toggle: () => null,
  reset: () => null,
});

export function useA11y() {
  return useContext(A11yContext);
}
